import React, { Component } from 'react';
import generalClasses from '../../GeneralFormComponent/GeneralFormComponent.module.scss';
import classes from './GalleryField.module.scss';
import classNames from 'classnames';
import Dropzone from 'react-dropzone';
import Typography from '@material-ui/core/Typography';
import { IGalleryField } from '../formFields';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Directives from '../../../Directives/Directives';
import Fab from '@material-ui/core/Fab';
import { Close } from '@material-ui/icons';
import Snackbar from '@material-ui/core/Snackbar';
import { translate } from '../../../../helperFunctions/translation';

interface IProps extends IGalleryField {
  errors?: any;
  touched?: any;

  onAddImage(name: string, image: File): void;

  onRemoveImage(name: string, imageIndex: number): void;
}

class GalleryField extends Component<IProps> {

  state = {
    open: false,
  };

  handleClose = () => {
    this.setState({ open: false });
  }
  onDrop = (acceptedFiles: File[], rejectedFiles: any) => {
    for (let file of acceptedFiles) {
      if (this.props.accept === 'image/*' && this.props.ratio) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (entry: any) => {
          const image = new Image();
          image.src = entry.target.result;
          image.onload = () => {
            let aspectRatio = image.width / image.height;
            let ratio = this.props.ratio || 0;
            if (aspectRatio < ratio) {
              this.setState({
                open: true,
              });
            } else {
              this.props.onAddImage(this.props.name, file);
            }
          };
        };
      } else {
        this.props.onAddImage(this.props.name, file);
      }
    }
  }

  getImage(element: any, index: number) {
    return (
      <div className={classes.thumb} key={`${element.imageUrl}${element.key}`}>
        <div className={classes.thumbInner}>
          <img src={element.imageUrl} className={classes.img} />
          <Fab size='small'
            color='secondary'
            aria-label='remove'
            onClick={() => this.props.onRemoveImage(this.props.name, index)}
            className={classes.remove}>
            <Close />
          </Fab>
        </div>
      </div>
    );
  }

  getVideo(element: any, index: number) {
    return (
      <div className={classes.thumb} key={`${element.videoUrl}${element.key}`}>
        <div className={classes.thumbInner}>
          <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ7mqlAlw416LNquaSAtkJG-Ace7tW8I_cjD8_KPI5DDWGZRyVt'
            className={classes.img} />
          <Fab size='small'
            color='secondary'
            aria-label='remove'
            onClick={() => this.props.onRemoveImage(this.props.name, index)}
            className={classes.remove}>
            <Close />
          </Fab>
        </div>
      </div>
    );
  }

  render() {
    const { value } = this.props;

    const thumbs = value!.map((element: any, index: number) => (
      (element.preview) ? (
        <div className={classes.thumb} key={element.preview}>
          <div className={classes.thumbInner}>
            {element.type.match(/video\/*/g) ?
              <img src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ7mqlAlw416LNquaSAtkJG-Ace7tW8I_cjD8_KPI5DDWGZRyVt'
                className={classes.img} />
              :
              <img src={element.preview} className={classes.img} />
            }
            <Fab size='large'
              color='secondary'
              aria-label='remove'
              onClick={() => {
                if (this.props.onRemoveImage)
                return this.props.onRemoveImage(this.props.name, index);
              }
              }
              className={classes.remove}>
              <Close />
            </Fab>
          </div>
        </div>
      ) : (
          element.type === 'video' ? this.getVideo(element, index) : this.getImage(element, index)
        )
    ));

    return (
      <FormControl className={generalClasses.filed}>
        <div className={classNames(classes.gallery)}>
          <Typography variant='caption' gutterBottom className={classNames(classes.label)}>
            {this.props.label}
          </Typography>
          <Dropzone onDrop={this.onDrop}>
            {({ getRootProps, getInputProps }) => (
              <section>
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <p style={{fontSize:'16px',margin:'1rem 0'}}>Drag 'n' drop some files here, or click to select files</p>
                </div>
              </section>
            )}
          </Dropzone>
          <div className={classes.thumbsContainer}>
            {thumbs}
          </div>
        </div>
        {this.state.open ? <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={this.state.open}
          onClose={this.handleClose}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id='message-id'>{translate('addBranchPageFormMasterPlanSnakbarMessage', {})}</span>} /> : ''
        }

        <Directives dIf={this.props.errors[this.props.name] && this.props.touched[this.props.name]}>
          <FormHelperText className={generalClasses.error}>{this.props.errors[this.props.name]}</FormHelperText>
        </Directives>
        <Directives dIf={!(this.props.errors[this.props.name] && this.props.touched[this.props.name]) && this.props.warningMessage
          && this.props.value!.length === 0}>
          <FormHelperText>{this.props.warningMessage}</FormHelperText>
        </Directives>
      </FormControl>
    );
  }
}

export default GalleryField;
